export * from "./speaker-page.view";
export * from "./template-config";
export * from "./image-config";
export * from "./region-config";
export * from "./html-config";
export * from "./label-config";
export * from "./button-config";
